<template>
  <el-drawer
    title="时间"
    :visible.sync="addTimeShow"
    :before-close="close"
    custom-class="wrap-head-16"
    :size="1280">
    <div class="flex bg-f5f5f5 set-height">
      <div class="left-setting flex-1 mr-4 p-4 overflow-auto box-border bg-white relative">  
        <el-form ref="ruleForm" :model="ruleForm" label-width="84px" :hide-required-asterisk="true">
          <el-form-item label="时间类别：" prop="level">
            <el-radio-group v-model="ruleForm.level" @change="changeTimeClass">
              <el-radio :label="1">年度</el-radio>
              <el-radio :label="2">季度</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="时间范围：" prop="range">
            <el-select v-model="ruleForm.rangeStar" placeholder="请选择" style="width:159px" @change="changeStartTime">
              <el-option :label="item.label" :value="item.label" v-for="item in rangeStarSelect" :key="item.value"></el-option>
            </el-select>
            <span class="mx-2">至</span>
            <el-select v-model="ruleForm.rangeEnd" placeholder="请选择" style="width:159px" @change="changeEndTime">
              <el-option :label="item.label" :value="item.label" v-for="item in rangeEndSelect" :key="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="flex w-full text-theme-black-850 text-sm mb-2">
          <p class="text-right" style="width: 84px">设置数据源：</p>
          <div class="flex tab-data-source text-center cursor-pointer text-theme-black-650">
            <p @click="changeDataSource('vary')" :class="[dataSource == 'vary' ? 'activeSource' : '']">不同数据源</p>
            <p @click="changeDataSource('same')" :class="[dataSource == 'same' ? 'activeSource' : '']">相同数据源</p>
          </div>
        </div>
        <div v-if="dataSource == 'vary'" class="bg-f5-table">
          <data-table ref="tableRef" class="w-full h-full overflow-hidden bg-f5-table"
            row-class-name="time-row-wrap text-theme-black-650" header-cell-class-name="timer-head-cell-wrap text-theme-black-450" align="left" :data="timeTableList"
            :loading="tableLoading" :columns="columns" :page="page" :bottomSpacing="false" rowKey="name"
            selection @selection-change="changeSelected" :showTooltip="false">
            <template slot="surveyId"  slot-scope="{ row }">
              <el-select v-model="row.surveyId" placeholder="请选择" :disabled="row.disableSel" class="table-select-wj bg-white table-select-custom-bg"
              :style="{width: `calc(${columns[1].width} - 20px)`}" @change="changeSelWj($event,row)">
                <el-option :label="item.surveyTitle" :value="item.surveyId" v-for="item in dataSourceList[0]?.children" :key="item.surveyId">
                  <span class="flex items-center"><span>{{item.surveyTitle}}</span>
                    <template v-if="item.relation">
                      <span class="ml-2 text-yellow-600">与地区有关联</span>
                      <el-tooltip placement="right" popper-class="init-area-tip">
                        <div slot="content" class="tipword pl-4 py-3">
                          <time-setting-tip />
                        </div>
                        <img src="@/assets/img/index-stat/tip1.png" class="ml-0.5" />
                      </el-tooltip>
                    </template>
                  </span>
                </el-option>
              </el-select>
              <p v-if="indexStatInfo.surveyId && row.surveyId && !relationWj.includes(row.surveyId)" style="color: #E8A31B;margin-top:2px" class="font-medium text-xs flex items-center">
                <el-tooltip placement="right" popper-class="init-area-tip">
                  <div slot="content" class="tipword pl-4 py-3">
                    <time-setting-tip />
                  </div>
                  <img src="@/assets/img/index-stat/tip1.png" class="mr-1" />
                </el-tooltip>
              该数据源与地区数据源没有关联数据，请确认是否合理</p>
            </template>
            <template #empty>
              <slot name="empty" v-if="$slots['empty']"></slot>
              <el-empty v-else></el-empty
              ><!-- 默认：图片+暂无数据 -->
            </template>
            <template #page-left>
              <div class="flex items-center mt-3 pb-4">
                <p class="ml-4 mr-12.5 text-medium text-theme-black-650 flex items-center">
                  <el-checkbox v-model="checkPageAll">
                    <span class="">已选择 <span class="text-theme">{{ checkAll ? page.total : selectList.length }}</span> 项</span>
                  </el-checkbox>
                </p>
                <div class="flex flex-col">
                  <el-select v-model="allSelectWj" placeholder="请选择" :disabled="selectList.length==0" @change="changeBatchSel" class="table-select-wj bg-white"
                  :style="{'margin-left': ruleForm.level == 1 ? '10px' : '58px',width: `calc(${columns[1].width} - 20px)`}">
                    <el-option :label="item.surveyTitle" :value="item.surveyId" v-for="item in dataSourceList[0]?.children" :key="item.surveyId">
                      <span class="flex items-center"><span>{{item.surveyTitle}}</span>
                        <template v-if="item.relation">
                          <span class="ml-2 text-yellow-600">与地区有关联</span>
                          <el-tooltip placement="right" popper-class="init-area-tip">
                            <div slot="content" class="tipword pl-4 py-3">
                              <time-setting-tip />
                            </div>
                            <img src="@/assets/img/index-stat/tip1.png" class="ml-0.5" />
                          </el-tooltip>
                        </template>
                      </span>
                    </el-option>
                  </el-select>
                  <p v-if="indexStatInfo.surveyId && allSelectWj && !relationWj.includes(allSelectWj)" :style="{color: '#E8A31B','margin-top':'2px','margin-left': ruleForm.level == 1 ? '10px' : '58px'}" class="font-medium text-xs flex items-center">
                  <el-tooltip placement="right" popper-class="init-area-tip">
                    <div slot="content" class="tipword pl-4 py-3">
                      <time-setting-tip />
                    </div>
                    <img src="@/assets/img/index-stat/tip1.png" class="mr-1" />
                  </el-tooltip>
                该数据源与地区数据源没有关联数据，请确认是否合理</p>
                </div>
              </div>
            </template>
          </data-table>
        </div>
        <div v-else>
          <div class="flex bg-f5-table same-data-source px-4 py-3 box-border items-center">
            <p class="text-sm text-theme-black-850 mr-5">数据源</p>
            <div class="flex flex-col">
              <el-select v-model="sameSelectWj" placeholder="请选择" class="bg-white table-select-wj" style="width: 384px" @change="changeSameSource">
                <el-option :label="item.surveyTitle" :value="item.surveyId" v-for="item in dataSourceList[0]?.children" :key="item.surveyId">
                  <span class="flex items-center"><span>{{item.surveyTitle}}</span>
                    <template v-if="item.relation">
                      <span class="ml-2 text-yellow-600">与地区有关联</span>
                      <el-tooltip placement="right" popper-class="init-area-tip">
                        <div slot="content" class="tipword pl-4 py-3">
                          <time-setting-tip />
                        </div>
                        <img src="@/assets/img/index-stat/tip1.png" class="ml-0.5" />
                      </el-tooltip>
                    </template>
                  </span>
                </el-option>
              </el-select>
              <p v-if="indexStatInfo.surveyId && sameSelectWj && !relationWj.includes(sameSelectWj)" style="color: #E8A31B;margin-top:2px" class="font-medium text-xs flex items-center">
                  <el-tooltip placement="right" popper-class="init-area-tip">
                    <div slot="content" class="tipword pl-4 py-3">
                      <time-setting-tip />
                    </div>
                    <img src="@/assets/img/index-stat/tip1.png" class="mr-1" />
                  </el-tooltip>
                该数据源与地区数据源没有关联数据，请确认是否合理</p>
            </div>
          </div>
        </div>
        <div class="footer-btns flex justify-end fixed p-4 right-0 bottom-0 box-border footer-time-btns bg-white z-50">
          <!-- <el-button type="default" @click="close">取消</el-button> -->
          <el-button class="primary-btn-style" type="primary" @click="handelConfirm('ruleForm')">提交</el-button>
        </div>
      </div>
      <div class="right-tip-word overflow-y-auto overflow-x-hidden py-4 pr-4 bg-white box-border mr-4">
        <h4>时间</h4>
        <p>构建时间维度，可查看和分析各指标的时间变化趋势。</p>
        <img src="@/assets/img/index-stat/area-tip.png" alt="">
        <div class="line-show"></div>
        <h4 class="mt-2">配置数据源目的</h4>
        <p>指标的数值可通过数据源直接取值或者计算得出。</p>
        <p>例如：指标：全年营业额</p>
        <ol>
          <li class="pl-8 mb-2 text-theme-black-850">如果数据源已有【全年营业额】数据，则直接取该数值；</li>
          <li class="pl-8 mb-2 text-theme-black-850">如果只有【各月营业额】，则需要将【各月营业额】，则需要各月营业额相加计算得到【全年营业额】</li>
        </ol>
        <div class="line-show"></div>
        <h4>各时间数据源</h4>
        <p>连续多次（例如每年开展一次调查）针对同一用户群体进行调查时</p>
        <ol>
          <li class="pl-8 mb-2 text-theme-black-850"><span>如果每次调查问卷都是不同问卷，则各时间维度的数据源不同，选择时间维度数据源应该是不同数据源</span></li>
          <li class="pl-8 mb-2 text-theme-black-850">如果每次调查问卷都用同一个调查问卷，仅通过问卷中的某个题目（或者提交时间）来区分多次提交数据时，则各时间维度的数据源相同，数据范围不同</li>
        </ol>
        <div class="line-show"></div>
        <h4>时间和地区关联数据</h4>
        <time-setting-tip :showWidth="290" />
      </div>
    </div>
  </el-drawer>
</template>

<script>
import DataTable from '@/components/base/DataTable'
import GlobalConfig from '@/global/config'
import { mapGetters } from 'vuex'
import TimeSettingTip from './TimeSettingTip'
import { timeDimensionCreate, timeDimensionUpdate } from '@/api/index-statistics'
import mixin from '../mixin.js'
export default {
  components: {DataTable,TimeSettingTip},
  mixins: [mixin],
  props: {
    addTimeShow: Boolean
  },
  watch: {
    selectList: {
      handler(v) {
        const selIds = this.selectList.map(item => item.name)
        this.timeTableList.forEach(item => {
          item.disableSel = selIds.includes(item.name)
          item.surveyId = selIds.includes(item.name) ? this.allSelectWj ||item.surveyId : item.surveyId
          const curSelWj =this.dataSourceList[0]?.children.find(child => child.surveyId == item.surveyId)
          item.surveyTitle = curSelWj?.surveyTitle
        })
        this.$nextTick(()=>{
          if(this.$refs.tableRef) this.$refs.tableRef.doLayout()
          this.$forceUpdate()
        })
        
      },
      deep: true
    },
    async addTimeShow(v){
      if(v){
        this.getDataSourceList(false)
        await this.getTimeDimensionList()
        this.timeTableList.forEach((item,index) => {
          this.$set(this.timeTableList,index,{
            ...item,
            surveyId: '',
            disableSel: false
          })
        })
        
        this.$nextTick(()=>{
          if(this.$refs.tableRef){
            this.$refs.tableRef.clearSelection()
            this.$refs.tableRef.doLayout()
          }
          this.$forceUpdate()
        })
        // this.ruleForm.rangeStar = this.rangeStarSelect[0].value
        // this.ruleForm.rangeEnd = this.rangeStarSelect[this.rangeStarSelect.length - 1].value
        if(this.timeTreeData.length > 0) {
          this.timeTableList = this.timeTreeData
          this.dataSource = this.timeTreeData[0]?.sameDataSource ? 'same' : 'vary'
          this.sameSelectWj = this.timeTreeData[0]?.sameDataSource ? this.timeTreeData[0]?.surveyId : ''
          this.ruleForm.level = this.timeTreeData[0].level
          this.ruleForm.rangeEnd = this.timeTreeData[this.timeTreeData.length - 1].name
          this.ruleForm.rangeStar = this.timeTreeData[0].name
          this.$forceUpdate()
        }else{
          this.selectList = []
          this.timeTableList = []
          this.dataSource = 'vary'
          this.sameSelectWj = ''
          this.allSelectWj = ''
          this.ruleForm.rangeStar = ''
          this.ruleForm.rangeEnd = ''
          this.$forceUpdate()
          this.formatTimeTable()
        }
      }
    }
  },
  data() {
    return {
      ruleForm: {
        rangeStar: '',
        rangeEnd: '',
        level: 1
      },
      years: [],
      quarterList:[],
      list: [
        { id: "1", name: '2017年第1季度', surveyId: '', data: ['问卷1','问卷2','问卷3','问卷4']},
      ],
      tableLoading: false,
      page: {
        current: 1,
        pageSizes: [10, 20, 30, 40, 50],
        size: 10,
        total: 7
      },
      selectList: [],
      checkAllSource: false,
      allSelectWj: '', //批量设置关联问卷
      sameSelectWj: '',//相同数据源关联问卷
      dataSource: 'vary',
      timeTableList: [],
      strYears: '',
      strQuarters: ''
    }
  },
  computed: {
    ...mapGetters(['indexStatInfo']),
    getSurveyId() {
      return GlobalConfig.getSurveyId()
    },
    columns() {
      if(this.ruleForm.level == 1){
        return [
        { fixed: false, label: '时间维度', value: 'name', width: '60px' },
        { fixed: false, label: '数据源', value: 'surveyId', width: '800px' },
      ]
      }else{
        return [
          { fixed: false, label: '时间维度', value: 'name', width: '110px' },
          { fixed: false, label: '数据源', value: 'surveyId', width: '750px' },
        ]
      }
    },
    checkAll: {
      get() {
        if (this.page.total === 0) return false
        return this.selectList.length === this.page.total ? true : this.checkAllSource
      },
      set(bool) {
        if (!bool) {
          this.selectList.splice(0)
          if(this.$refs.tableRef) this.$refs.tableRef.clearSelection()
        }
        this.checkAllSource = bool
      }
    },
    checkPageAll: {
      get() {
        if (this.timeTableList.length === 0) return false
        return this.selectList.length > 0
      },
      set() {
        const table = this.$refs.tableRef
        if (table) {
          if(this.selectList.length > 0){
            table.clearSelection()
          }else{
            table.toggleAllSelection()
          }
        }
      }
    },
    rangeStarSelect() {
      return this.ruleForm.level == 2 ? this.quarterList : this.years
    },
    rangeEndSelect() {
      let index = this.rangeStarSelect.findIndex(item => {
        return item.label == this.ruleForm.rangeStar
      })
      return index >= 0 ? this.rangeStarSelect.slice(index) : this.rangeStarSelect
    },
    relationWj() {
      const filterRelation = this.dataSourceList[0]?.children.filter(item => item.relation)
      const surveyIds = filterRelation?.map(item => item.surveyId)
      return surveyIds || []
    }
  },
  created() { },
  mounted() {
    this.quarterList = this.getYearSeasonList()
    const year = new Date().getFullYear()
    this.getAllYear(year)
    this.years.reverse()
    this.strYears = JSON.stringify(this.years)
    this.strQuarters = JSON.stringify(this.quarterList)
  },
  methods: {
    formatTimeTable(data){
      // if(data == 'batch') debugger
      let jsonYears = JSON.parse(this.strYears)
      let jsonQuarters = JSON.parse(this.strQuarters)
      let startIndex = 0
        let endIndex = 0
        let timeList = []
        if(this.ruleForm.level == 1){
          startIndex = jsonYears.findIndex(item => item.value == this.ruleForm.rangeStar)
          endIndex = jsonYears.findIndex(item => item.value == this.ruleForm.rangeEnd)
          timeList = jsonYears.slice(startIndex, endIndex + 1)
        } else {
          startIndex = jsonQuarters.findIndex(item => item.value == this.ruleForm.rangeStar)
          endIndex = jsonQuarters.findIndex(item => item.value == this.ruleForm.rangeEnd)
          timeList = jsonQuarters.slice(startIndex, endIndex + 1)
        }
        // 批量选中问卷处理
        const selIds = this.selectList.map(item => item.name)
        timeList.forEach((item) => {
          item.surveyId = selIds.includes(item.name) ? this.allSelectWj : item.surveyId
          item.disableSel = selIds.includes(item.name)
          const curSelWj =this.dataSourceList[0]?.children.find(child => child.surveyId == item.surveyId)
          item.surveyTitle = curSelWj?.surveyTitle
          item.name = item.label || item.name
          item.level = this.ruleForm.level
          item.indicatorStatisticsId = this.indexStatInfo.id
          item.id = item.id || ''
        })
        // 相同数据源处理
        if(this.dataSource == 'same'){
          timeList.forEach((item) => {
            item.surveyId = this.sameSelectWj
            const curSelWj =this.dataSourceList[0]?.children.find(child => child.surveyId == item.surveyId)
            item.surveyTitle = curSelWj?.surveyTitle
            item.name = item.label
            item.level = this.ruleForm.level
            item.indicatorStatisticsId = this.indexStatInfo.id
            item.id = ''
          })
        }
        
        this.timeTableList = timeList
    },
    changeDataSource(data) {
      this.dataSource = data
      this.selectList = []
      this.sameSelectWj = ''
      this.allSelectWj = ''
      this.$forceUpdate()
      this.formatTimeTable()
    },
    changeSameSource(data){
      this.formatTimeTable()
    },
    changeStartTime(){
      this.formatTimeTable()
    },
    changeEndTime() {
      this.formatTimeTable()
    },
    // 创建时间维度
    addTimeDimension() {
      timeDimensionCreate(this.timeTableList).then(res => {
      })
    },
    changeSelWj(e,row) {
      const curSelWj =this.dataSourceList[0]?.children.find(item => item.surveyId == e)
      const curIndex = this.timeTableList.findIndex(item => item.name == row.name)
      this.timeTableList[curIndex].surveyId = e
      this.timeTableList[curIndex].surveyTitle = curSelWj?.surveyTitle
      this.$set(this.timeTableList,curIndex,row)
      if(this.$refs.tableRef) this.$refs.tableRef.doLayout()
    },
    // 修改时间维度
    editTimeDimension() {
      timeDimensionUpdate({
        indicatorStatisticsId: this.indexStatInfo.id,
        sameDataSource: this.dataSource == 'same',
        timeDimensionDTOS: this.timeTableList
      }).then(res => {
        
        if(res.data.code == 0 && res.data.data){
          this.$parent.getTimeDimensionList()
          this.$emit('update:addTimeShow', false)
          //更新指标树
          this.$parent.getIndexDimensionList()
          // 更新表格
          this.$emit('updataCellTable')
        }
      })
    },
    close() {
      this.selectList = []
      this.ruleForm = {
        rangeStar: '',
        rangeEnd: '',
        level: 1
      }
      this.sameSelectWj = ''
      this.allSelectWj = ''
      this.timeTableList = []
      this.$forceUpdate()
      this.$emit('update:addTimeShow', false)
    },
    handelConfirm(formName) {
      this.ruleForm.indicatorStatisticsId = this.indexStatInfo.id
      if(this.timeTableList.length < 1) {
        this.$message.warning('不存在可保存的时间维度！')
        return
      }
      this.timeTableList.forEach(item => {
        if(!item.surveyId){
          this.$message.warning('请配置完整时间维度！')
          throw new Error('请配置完整时间维度！')
        }
      })
      this.editTimeDimension()
    },
    // 获取2017至今的所有季度
    getYearSeasonList(){
      const YEARS = new Date().getFullYear() - 2017 + 1;
      var currentMonth = new Date().getMonth() + 1;
      const getCurrentSeason =  Math.floor((currentMonth % 3 === 0 ? (currentMonth / 3) : (currentMonth / 3 + 1)));
      var dataArr = []
      var list = []
      var seasonList = [{
              label: '第 4 季度',
              monthList: ['10', '11', '12']
          },
          {
              label: '第 3 季度',
              monthList: ['07', '08', '09']
          },
          {
              label: '第 2 季度',
              monthList: ['04', '05', '06']
          },
          {
              label: '第 1 季度',
              monthList: ['01', '02', '03']
          }
      ]
      var currentYear = new Date().getFullYear()
      for (var i = 0; i < YEARS; ++i) {
          for (var j = 0; j < seasonList.length; ++j) {
              list.push({
                  label: (currentYear - i) + ' 年' + seasonList[j].label,
                  value: (currentYear - i) + ' 年' + seasonList[j].label,
                  // value: (currentYear - i) + '' + seasonList[j].monthList[0] + ',' + (currentYear - i) + '' + seasonList[j].monthList[1] + ',' + (currentYear - i) + '' + seasonList[j].monthList[2]
              })
          }
      }
      return dataArr.concat(list.splice(4 - getCurrentSeason, list.length)).reverse()
    },
    // 获取2012至今的所有年份
    getAllYear(year) {
      const obj = {
        label: year,
        value: year
      }
      this.years.push(obj)
      year--
      if(year > 2011){
        this.getAllYear(year)
      }else{
        return
      }
    },
    changeSelected(list) {
      this.selectList = list;
    },
    changeBatchSel(e){
      const selIds = this.selectList.map(item => item.name)
      this.timeTableList.forEach((item,index) => {
        let obj = {}
        obj.surveyId = selIds.includes(item.name) ? this.allSelectWj : item.surveyId
        obj.disableSel = selIds.includes(item.name)
        const curSelWj =this.dataSourceList[0]?.children.find(child => child.surveyId == e)
        obj.surveyTitle = curSelWj?.surveyTitle
        obj.name = item.label || item.name
        obj.level = this.ruleForm.level
        obj.indicatorStatisticsId = this.indexStatInfo.id
        obj.id = item.id || ''
        this.$set(this.timeTableList,index,obj)
      })
      this.$forceUpdate()
    },
    changeTimeClass(){
      // this.ruleForm.rangeStar = this.rangeStarSelect[0].value
      // this.ruleForm.rangeEnd = this.rangeStarSelect[this.rangeStarSelect.length - 1].value
      this.ruleForm.rangeStar = ''
      this.ruleForm.rangeEnd = ''
      this.selectList = []
      if(this.$refs.tableRef){
        this.$refs.tableRef.clearSelection()
        this.$refs.tableRef.doLayout()
      }
      this.formatTimeTable()
    }
  }
}
</script>

<style lang="scss">
.wrap-head-16{
  .el-drawer__header{
    padding: 11px 16px !important;
  }
}
.time-row-wrap{
  background: #f5f5f5 !important;
}
.timer-head-cell-wrap{
  background: #f5f5f5 !important;
}
.left-setting{
  .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: none !important;
  }
  .el-table.data-table .el-table__cell{
    height: 40px;
    color: rgba(0, 0, 0, 0.65);
  }
}
.table-select-wj{
  width: 680px;
  .el-input__inner{
    background: #fff;
  }
}
.table-select-custom-bg{
  .el-input.is-disabled .el-input__inner{
   background: #e8e8e8 !important; 
  }
}
.add-area-datasource-cascader{
  .el-scrollbar__view.el-cascader-menu__list{
    max-width: 300px !important;
  }
}
</style>
<style lang="scss" scoped>
.set-height{
  height: calc(100vh - 50px) !important;
  min-height: calc(100vh - 50px) !important;;
  overflow-y: hidden;
}
::v-deep .bg-f5-table .el-table th.el-table__cell:nth-child(2)>.cell{
    padding: 0 !important;
}
::v-deep .bg-f5-table .el-table td.el-table__cell:nth-child(2) div{
  padding: 0 !important;
}
::v-deep .bg-f5-table .el-table th.el-table__cell:nth-child(1)>.cell{
    padding-right: 0 !important;
    padding-left: 0px !important;
}
::v-deep .bg-f5-table .el-table td.el-table__cell:nth-child(1) div{
  padding-right: 0 !important;
  padding-left: 0px !important;
}
.bg-f5-table{
  background: #f5f5f5 !important;
}
.right-tip-word{
  height: calc(100vh - 48px);
  ol li {
    font-size: 14px;
    line-height: 24px;
  }
  ol li::before{
    content: "\2022  ";
    font-size: 22px;
    color: rgba(0,0,0,0.15);
    margin-left: -16px;
  }
}
.left-setting{
  // padding-bottom: 65px;
  max-height: calc(100vh - 113px);
  overflow: overlay;
  // min-height: 702px;
}
.tab-data-source{
  p{
    width: 108px;
    border: 1px solid rgba(0,0,0,0.15);
    border-radius: 2px 0 0 2px;
  }
  .activeSource{
    color: #308AF7;
    background: #F0F8FF;
    // border: 1px solid #2775E8;
    @apply border border-solid border-theme;
  }
  p:nth-child(1){
    // border-right: 1px solid #2775e8;
    // @apply border-r border-solid border-theme;
  }
  p:nth-child(2){
    border-radius: 0 2px 2px 0;
    // border-left: none;
  }
}
.footer-time-btns{
  width: 958px;
  right: 322px;
}
.same-data-source{
  height: 56px;
}
</style>
